import React from "react";
import { connect } from 'react-redux';
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    BreadcrumbItem,
    Row,
    Col,
    Breadcrumb,
} from "reactstrap";

import cogoToast from "cogo-toast";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import DashboardLayout from "layouts/Admin";
import { Routes, Validations } from 'constants/index.js';
import { DocumentActions } from "actions/index.js";
import { createQuery } from "api/index.js";
import { AvField, AvForm } from "availity-reactstrap-validation";

var selectOptions = [
    { value: "missing page", label: "Missing Page" },
    { value: "scan not clear", label: "Scan Not Clear" },
    { value: "scan partially obstructed", label: "Scan Partially Obstructed" },
    { value: "scan of different documents to meta data", label: "Scan Of Different Documents To Meet Data" },
];

class RaiseImageQuery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            designation: null,
            queryDetails: "",
            queryType: "Image Query",
            isUploading:false
        };
        this.onChange = this.onChange.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.createImage = this.createImage.bind(this);

    }
    componentDidMount() {
        this.props.getDocumentDetails(this.props.token, this.props.match.params.id);
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    onCancel() {
        this.props.history.push(`${Routes.DOCUMENTS}/${this.props.match.params.id}`);
    }

    createImage = async (event, values) => {
        this.setState({ isUploading: true });

        try {
            //IMAGE_QUERY,SDV_QUERY,SOURCE_DATA_QUERY,META_DATA_QUERY
            let details = this.props.details[this.props.match.params.index];
            let monitorDocQueryObj = {
                subject: details.subject.id,
                studySite: details.studySite.id,
                monitorDocument: details.id,
                docVersion: String(details.versionedDocument.length),
                queryType: "IMAGE_QUERY",
                query: values.queryDetails,
                title: values.title,
                queryStatus: 'OPENED',
                owner: this.props.user.staffProfile._id,
                cancelRemarks: "",
                isDeleted: false,
            }
            await createQuery(this.props.token, monitorDocQueryObj);
            const { hide } = cogoToast.success('Image query raised successfully.', {
                onClick: () => {
                    hide();
                },
                position: "top-right",
                hideAfter: 3
            });
            this.props.history.push(`${Routes.DOCUMENTS}/${this.props.match.params.id}`);
        } catch (error) {
            console.log(error);
            cogoToast.error('Failed to create query.')
            this.setState({ isUploading: false });
        }
        

    }
    render() {
        const {isUploading } = this.state;
        return (
            <DashboardLayout>
                <PanelHeader size="sm" >
                    <Col>
                        <Breadcrumb tag="nav" listTag="div">
                            <BreadcrumbItem tag="a" href={`${Routes.DASHBOARD}`}>Home</BreadcrumbItem>
                            <BreadcrumbItem tag="a" href={`${Routes.DOCUMENTS}`} >Documents</BreadcrumbItem>
                            <BreadcrumbItem active tag="span">Document Details</BreadcrumbItem>
                            <BreadcrumbItem active tag="span">Image Query</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </PanelHeader>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h5">Raise Image Query</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Col sm={5}>
                                        <AvForm onValidSubmit={this.createImage}>
                                            <AvField label="Query Type" name="queryType" type="text" placeholder="Image Query" disabled defaultValue={this.state.queryType} />
                                            <AvField className="minimal" type="select" placeholder="Scan type" name="title" label="Scan Type"
                                                validate={{
                                                    required: { value: true, errorMessage: 'Please select a trail praticipant.' }
                                                }} >
                                                <option value="">Select</option>
                                                {
                                                    selectOptions.map(val => {
                                                        return <option key={val.value} value={val.value}>{val.label}</option>
                                                    })
                                                }
                                            </AvField>
                                            <AvField name="queryDetails" autoComplete="off" label="Query Details" type="textarea" validate={{
                                                required: { value: true, errorMessage: 'Please enter Query Details.' },
                                                pattern: Validations.MULTI_LINE_ALPHA_NUMERICS_WITH_SPECIAL_CHARS,
                                                minLength: { value: 6, errorMessage: 'Query Details must be at least 6 characters' },
                                                maxLength: { value: 500, errorMessage: 'Query Details must not be more than 500 characters.' },
                                            }} />

                                            <Row>
                                                <Button color="primary ml-5" className="btn-round" size="sm" type="submit" disabled={isUploading}>
                                               {isUploading ? 'Please wait..' : 'Raise Image Query'}                                                 
                                            </Button>
                                                <Button color="primary" className="btn-round ml-3" outline size="sm" type="button" onClick={this.onCancel}>
                                                    Cancel
                                            </Button>
                                            </Row>
                                        </AvForm>
                                    </Col>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </DashboardLayout>
        )
    }
}
const mapStateToProps = ({ user, documents, studies }) => {
    return {
        token: user.token,
        details: documents.details,
        study: studies.myStudy,
        user: user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getDocumentDetails: (token, id) => DocumentActions.getDocumentDetails(dispatch, token, id),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(RaiseImageQuery);

